document.addEventListener('DOMContentLoaded', function () {
  const cartSummaryElements = document.querySelectorAll('.cart-summary');
  const raffleEntryElements = document.querySelectorAll('.raffle-entry');
  const cartDetailsContainer = document.querySelector('.cart-detial-container_images'); // For displaying products

  // Helper function to format money
  const formatMoney = (cents) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(cents / 100);
  };

  // Function to calculate raffle entries
  const calculateRaffleEntries = (totalPrice) => {
    return Math.floor(totalPrice / 20000);
  };

  // Function to update all cart summary and raffle entry elements
  const updateCartDisplays = (totalItems, totalPrice, raffleEntries) => {
    cartSummaryElements.forEach((cartSummary) => {
      cartSummary.textContent = `${totalItems} items, ${formatMoney(totalPrice)}, `;
    });

    raffleEntryElements.forEach((raffleEntry) => {
      raffleEntry.textContent = `${raffleEntries} raffle entr${raffleEntries !== 1 ? 'ies' : 'y'}`;
    });
  };

  // Function to render cart items
  const renderCartItems = (items) => {
    const productsHTML = items
      .map((item) => {
        return `
          <div class="cart-product">
            <img src="${item.image}" alt="${item.title}" class="cart-product-image" />
            <div class="cart-product-details">
              <p class="cart-product-title">${item.title}</p>
            </div>
          </div>
        `;
      })
      .join('');
    
    cartDetailsContainer.innerHTML = `
      <div class="cart-products-container">
        ${productsHTML}
      </div>
    `;
  };

  // Function to fetch and update cart data
  const fetchCartData = () => {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const totalItems = cart.item_count;
        const totalPrice = cart.total_price;
        const raffleEntries = calculateRaffleEntries(totalPrice);

        // Update cart summary and raffle entries
        updateCartDisplays(totalItems, totalPrice, raffleEntries);

        // Render cart items
        renderCartItems(cart.items);
      })
      .catch((error) => {
        console.error('Error fetching cart data:', error);
      });
  };

  // Add click event listener for dynamically loaded "Add to Cart" buttons
  document.body.addEventListener('mouseup', (event) => {
    const addToCartButton = event.target.closest('[data-add-to-cart]');
    if (addToCartButton) {
      setTimeout(fetchCartData, 2000);
    }
  });

  // Only fetch cart data if BYOB elements exist on the page
  if (cartSummaryElements.length > 0 || cartDetailsContainer) {
    fetchCartData();
  }

const maxLines = 2; // Maximum number of lines to display
const divs = document.querySelectorAll(".product-featured__content-text.rte");

divs.forEach(div => {
    const lineHeight = parseFloat(getComputedStyle(div).lineHeight); // Get the computed line height
    const maxHeight = lineHeight * maxLines;

    // Store the full text for toggling
    const fullText = div.textContent.trim(); 

    // Truncate the text if it's too long
    if (div.scrollHeight > maxHeight) {
      div.style.height = `${maxHeight + 9.5}px`;
        div.style.overflow = "hidden";
        div.style.textOverflow = "ellipsis";
        div.style.display = "-webkit-box";
        div.style.webkitBoxOrient = "vertical";
        div.style.webkitLineClamp = maxLines;

        // Add a "Read More" button
        const toggleButton = document.createElement("button");
        toggleButton.textContent = "Read More";
        toggleButton.style.display = "block";
        toggleButton.style.marginTop = "10px";

        toggleButton.addEventListener("click", function () {
            if (toggleButton.textContent === "Read More") {
                div.style.height = "auto";
                div.style.webkitLineClamp = "unset";
                div.style.overflow = "visible";
                toggleButton.textContent = "Show Less";
            } else {
                div.style.height = `${maxHeight}px`;
                div.style.webkitLineClamp = maxLines;
                div.style.overflow = "hidden";
                toggleButton.textContent = "Read More";
            }
        });

        div.insertAdjacentElement("afterend", toggleButton);
    }
});

});


